export default "__VITE_ASSET__CZmWS96T__"